import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import tabbarStyles from './TabbarStyles';

type TabbarProps = {
  tabs: TabContent[];
};

interface TabContent {
  id: string;
  label: string;
  title: string;
  description: React.ReactNode;
  image: string;
  disabled?: boolean;
}

const StyledTabbar = styled('section')(({ theme }) => tabbarStyles(theme));

const Tabbar: React.FC<TabbarProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  

  const handleTabClick = (tabId: string) => {
    if (!tabs.find(tab => tab.id === tabId)?.disabled) {
      setActiveTab(tabId);
    }
  };

  const activeTabContent = tabs.find(tab => tab.id === activeTab);

  return (
    <StyledTabbar className="lg:flex pb-8 lg:py-8 w-full">
      <ul id="tabbar-container" className="text-sm text-body items-center flex flex-col lg:!pl-3 lg:!pr-3 lg:pb-3 rounded-lg lg:my-4 ps-[0px] !px-6 ">
        <div className="w-full h-full border-solid  border-0  ">
          <div id="tabbar-inner-container" className="rounded-lg overflow-hidden p-2 lg:p-0">
            {tabs.map((tab) => (
              <li key={tab.id} className="w-full border-transparent flex pt-2 overflow-hidden">
                <button
                  onClick={() => handleTabClick(tab.id)} id="tab"
                  className={`flex justify-center items-center text-nowrap !rounded-lg text-[17px] px-4 rounded-base border-solid lg:rounded-none border-0 w-full transition-colors border-r-[4px] border-transparent py-2 ${
                    activeTab === tab.id
                      ? 'active-tab'
                      : ''
                  }`}
                  aria-current={activeTab === tab.id ? 'page' : undefined}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </div>
        </div>
      </ul>
      <div className="p-6 lg:px-4 py-4 lg:w-full lg:flex max-h-[unset] lg:max-h-[30rem]">
        <div id="tab-image-container" className="flex w-full lg:mr-4 rounded-xl overflow-hidden lg:w-1/2 xl:w-2/3 lg:h-[unset] mb-6 lg:mb-0">
          <img loading="lazy" 
            src={activeTabContent?.image} 
            alt={activeTabContent?.title}
            className="w-full h-full object-cover"
          />
        </div>
        <div id="tab-content" className="text-medium w-full rounded-xl lg:w-1/2 xl:w-1/3">
          <div className="p-6 pb-8">
            <h3 className="text-2xl font-semibold text-heading mb-4">{activeTabContent?.title}</h3>
            <div className="mb-2">{activeTabContent?.description}</div>
          </div>
        </div>
      </div>
    </StyledTabbar>
  );
};

export default Tabbar;